import { render } from "./Acceptance.vue?vue&type=template&id=18378263&scoped=true"
import script from "./Acceptance.vue?vue&type=script&lang=js"
export * from "./Acceptance.vue?vue&type=script&lang=js"

import "./Acceptance.vue?vue&type=style&index=0&id=18378263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18378263"]])

export default __exports__